"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
var constants_1 = require("./constants");
var state_1 = require("./state");
/** @public */
var State = /** @class */ (function () {
    function State(board, kings, turn, castling, ep_square, half_moves, move_number) {
        this.board = board || new Array(128);
        this.kings = kings || { w: constants_1.EMPTY, b: constants_1.EMPTY };
        this.turn = turn || constants_1.WHITE;
        this.castling = castling || { w: 0, b: 0 };
        this.ep_square = ep_square || constants_1.EMPTY;
        this.half_moves = half_moves || 0;
        this.move_number = move_number || 1;
    }
    State.prototype.clone = function () {
        return new State(this.board.slice(), {
            w: this.kings.w,
            b: this.kings.b,
        }, this.turn, {
            w: this.castling.w,
            b: this.castling.b,
        }, this.ep_square, this.half_moves, this.move_number);
    };
    Object.defineProperty(State.prototype, "fen", {
        get: function () {
            return state_1.getFen(this);
        },
        enumerable: false,
        configurable: true
    });
    return State;
}());
exports.State = State;
